import templateUrl from 'emun.order/ticket.htm'
import controller from 'emun.order/ticket.controller'

export default {
    bindings: {
		ticketId: '@'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};